module.exports = __webpack_public_path__ + "static/fcra-2017-18-q1-4098a0d03d221aa6f93f22d97f1c0958.pdf";